const reviews = [
  {
    id: 0,
    stars: 5,
    image: "/images/14-boostblogfood/sec5/Nico Hayes.jpeg",
    name: "Nico Hayes",
    title: "Home Baker & Content Creator",
    text: "Honestly, I used to post randomly and never got much interaction. It was frustrating trying to keep up" +
      " with content and figure out what actually worked. Since working with my SMM manager, everything’s been way " +
      "more consistent—and my engagement’s finally picking up! It’s such a relief not having to stress over every" +
      " little detail."
  },
  {
    id: 1,
    stars: 5,
    image: "/images/14-boostblogfood/sec5/Aarav Sharma.jpeg",
    name: "Aarav Sharma",
    title: "Plant-Based Chef & Cookbook Author",
    text: "I used to stress about what to post and when—my engagement was all over the place. Since I started working" +
      " with my SMM manager, everything's been flowing. Content? Sorted. Schedule? Handled. Now my Instagram’s " +
      "actually growing, and I don’t feel like I’m winging it anymore 🙌"
  },
  {
    id: 2,
    stars: 4,
    image: "/images/14-boostblogfood/sec5/Rowan Tate.jpeg",
    name: "Rowan Tate",
    title: "Food Stylist & Recipe Curator",
    text: "I didn’t expect much, but BoostBlogFood actually helped me get some real structure. My content’s more " +
      "consistent, and engagement is finally going somewhere. I do wish there were more creative options, but " +
      "overall? I’m impressed."
  },
  {
    id: 3,
    stars: 5,
    image: "/images/14-boostblogfood/sec5/Luna Rae.jpeg",
    name: "Luna Rae",
    title: "Gluten-Free Recipe Developer",
    text: "Working with BoostBlogFood seriously leveled things up 🙌 They helped me lock in my brand" +
      " vibe (finally!) and even connected me with some amazing influencers. My follower count’s been rising steadily, " +
      "but the best part? I get to focus on what I love most—creating food content 🍳📸"
  },
  {
    id: 4,
    stars: 5,
    image: "/images/14-boostblogfood/sec5/Aria S.jpeg",
    title: "Catering Specialist & Food Blogger",
    name: "Aria S",
    text: "BoostBlogFood helped me define my brand identity and connect with influencers who truly aligned with my " +
      "content. Thanks to their support, my follower count has grown significantly—and best of all, I now have more" +
      " time to focus on creating the food content I’m passionate about."
  },
  {
    id: 5,
    stars: 5,
    image: "/images/14-boostblogfood/sec5/Sloane Ellis.jpeg",
    name: "Sloane Ellis",
    title: "Private Chef & Kitchen Consultant",
    text: "Partnering with BoostBlogFood made a huge difference. They helped refine my brand identity and connected " +
      "me with influencers that actually fit my niche. My growth is up, and I finally get to focus on what I " +
      "love—creating food content."
  },
  {
    id: 6,
    stars: 4,
    image: "/images/14-boostblogfood/sec5/Neeha.png",
    name: "Neeha @SpiceNPlate",
    title: "Street Food Expert & Travel Vlogger",
    text: "Okay, so BoostBlogFood really helped me level up. My engagement’s up, my content looks more put together, " +
      "and I’m not just winging it anymore. I just wish there was a little more creative back-and-forth—but overall? " +
      "Solid 4/5."
  },
  {
    id: 7,
    stars: 5,
    image: "/images/14-boostblogfood/sec5/Meera.png",
    name: "Meera @TheToastySpoon",
    title: "Farm-to-Table Advocate & Culinary Coach",
    text: "My SMM manager handled everything—from strategy to visuals—and the results speak for themselves. Huge " +
      "follower growth, better engagement, and I’m not constantly stressed about what to post. 10/10 experience!"
  },
  {
    id: 8,
    stars: 4,
    image: "/images/14-boostblogfood/sec5/Anika.png",
    name: "Anika @TadkaTale",
    title: "Dessert Artist & Social Media Creator",
    text: "I’ve had a really positive experience so far with my social media manager. They took a lot off my " +
      "plate—especially the content planning and daily posting. My page is more active and professional-looking now." +
      " There were a few minor delays here and there, but I’m still super happy with the growth!"
  },
  {
    id: 9,
    stars: 4,
    image: "",
    imageBg: "bg-greenlight",
    name: "Reyansh @SavorySides",
    title: "Fermentation Enthusiast & Food Educator",
    text: "My food blog was kinda stuck, but BoostBlogFood gave it the push it needed. Their reports and strategy " +
      "stuff? Super helpful. I’ve grown way more consistent—and it’s showing. Not perfect, but honestly, it’s been a" +
      " really good experience."
  },
  {
    id: 10,
    stars: 5,
    image: "/images/14-boostblogfood/sec5/Arjun.png",
    name: "Arjun @MasalaMoments",
    title: "Sourdough Baker & Instagram Creator",
    text: "Can’t believe how much easier things are now. BoostBlogFood handles the strategy, keeps me on track, and " +
      "my engagement has seriously taken off. I get to focus on recipes, not algorithms!"
  },
  {
    id: 11,
    stars: 5,
    image: "",
    imageBg: "bg-pinklight",
    name: "Jake S.",
    title: "Culinary Photographer & Recipe Writer",
    text: "I used to struggle with getting noticed, but BoostBlogFood helped me find my voice and grow my audience. " +
      "Their monthly insights are gold, and the results speak for themselves."
  },
];

const reviewTemplate = document.getElementById("reviewTemplate");
const reviewsList = document.getElementById("reviewsList");
const maxNumber = reviews.length - 1;
let showReviews = []; // dynamic array
let lastChangedIndex = null;

function generateRandomId(exceptArray = showReviews, max = maxNumber) {
  const id = Math.floor(Math.random() * (max + 1));
  return exceptArray.some(num => num === id) ? generateRandomId(exceptArray, max) : id;
}

function generateTemplate(id, className = "") {
  const review = reviews.find(reviewObject => reviewObject.id === id);
  const template = reviewTemplate.content.cloneNode(true);
  if (className) {
    template.children[0].classList.add(className);
  }
  template.querySelector(".review-switcher__text").textContent = review.text;
  template.querySelector(".review-switcher__name").textContent = review.name;
  template.querySelector(".review-switcher__title").textContent = review.title;
  if (review.stars === 4) {
    template.querySelector(".review-switcher__stars li:last-child").classList.add("hidden");
  }
  const imgContainer = template.querySelector(".review-switcher__image");
  if (review.image) {
    imgContainer.querySelector("img").src = review.image;
  } else {
    imgContainer.querySelector("img").remove();
    imgContainer.textContent = review.name.charAt(0).toUpperCase();
    imgContainer.classList.add(review.imageBg, "pt-1");
  }
  return template
}

export function reviewsSwitcherLogic()  {
  if (!reviewTemplate || !reviewsList || !("content" in document.createElement("template"))) {
    return;
  }

  for (let i = 0; i < 4; i++) {
    const nextReviewId = generateRandomId(showReviews);
    showReviews.push(nextReviewId);
    const li = document.createElement("li");
    li.classList.add("col-xl-3", "col-lg-6", "review-switcher", "relative");
    li.setAttribute("data-id", nextReviewId);
    const innerDiv = document.createElement("div");
    innerDiv.classList.add("width-100", "relative", "review-switcher__inner");
    li.appendChild(innerDiv);
    innerDiv.appendChild(generateTemplate(nextReviewId));
    reviewsList.appendChild(li);
  }

  // console.log("showReviews", showReviews);

  let changeTimoutId = null;

  function launchReviewSlider() {
    clearTimeout(changeTimoutId);
    const randomReviewIndex = generateRandomId(
      Number.isInteger(lastChangedIndex) ? [lastChangedIndex] : [],
      3
    );
    lastChangedIndex = randomReviewIndex;
    const oldReviewId = showReviews[randomReviewIndex];
    const newReviewId = generateRandomId();
    showReviews = showReviews.map(reviewId => reviewId === oldReviewId ? newReviewId : reviewId); // slice
    // console.log("lastChangedId", lastChangedIndex, newReviewId, showReviews);
    const template = document.querySelector(`.review-switcher[data-id='${oldReviewId}']`);
    const oldCard = template.querySelector(".review-switcher__card");
    oldCard.classList.add("inactive");
    template.dataset.id = newReviewId;
    const innerDiv = template.querySelector(".review-switcher__inner");
    innerDiv.appendChild(generateTemplate(newReviewId, "active"));
    changeTimoutId = setTimeout(() => {
      innerDiv.querySelector(".review-switcher__card.active").classList.remove("active");
      innerDiv.querySelector(".review-switcher__card.inactive").remove();
      changeTimoutId = setTimeout(() => {
        if (window.innerWidth > 991) {
          launchReviewSlider();
        }
      }, 5000);
    }, 2000);
  }

  changeTimoutId = setTimeout(() => {
    launchReviewSlider();
  }, 5000);
}
